import { Injectable } from '@angular/core';
import {
  Router, Resolve,
  RouterStateSnapshot,
  ActivatedRouteSnapshot
} from '@angular/router';
import { Observable, of } from 'rxjs';
import { EventService } from './core/service/event.service';

@Injectable({
  providedIn: 'root'
})
export class AppResolver implements Resolve<boolean> {
 
  constructor(
    private eventsService: EventService,
  ) {
  }

  resolve(route: ActivatedRouteSnapshot, state: RouterStateSnapshot): Observable<boolean> {
    setTimeout(() => {
      this.eventsService.broadcast('toggleProjectMenu', {
        projectId: null,
      });
    }, 50)
    return of(true);
  }
}
